module.exports = __webpack_public_path__ + "img/img5.1d61080e.jpg";